{
  "JudgeJoinModalTitle": "Bienvenido a ",
  "JudgeJoinModalPhrase1": "Nos sentimos orgullosos de tenerte como juez.",
  "JudgeJoinModalPhrase2": "Haz saber a los concursantes y asistentes al evento quién eres.",
  "UploadProfilePic": "subir foto de perfil",
  "TitlePlaceholder": "título",
  "BioPlaceholder": "cuéntanos sobre ti",
  "BioNewPlaceholder": "Cuéntales a los asistentes al evento sobre ti. Te recomendamos que compartas tus logros recientes y tus pasiones.",
  "SkipForLater": "dejar para más tarde",
  "SubmitButton": "Enviar",
  "JudgeWelcomeRemark": "Esperando tu veredicto ... emm ... queria decir evaluación.",
  "WelcomJudge": "Evento del Hub - Bienvenido Juez",

  "ResourceJoinModalPhrase1": "Haz saber a los concursantes cómo les puedes ayudar.",
  "labelPlaceholder": "área de experiencia",
  "WelcomSupport": "Eventos del Hub - Soporte de bienvenida",

  "NoProjectsYet": "Aún no tienes ningún proyecto.",
  "SelectProjectLater": "seleccionar proyecto más tarde",
  "SubmitProject": "enviar mi proyecto",
  "CreateHubModal": "Crear un Hub modal",
  "CreateProject": "Crea un proyecto",
  "SelectProjectTitle": "Seleccionar Proyecto para ",
  "SelectProjectToCompete": "Select Project to compete in",
  "CurrentlySubmitted": "Enviado actualmente:",
  "SelectProjectFormPhrase1": "Todo",
  "SelectProjectFormPhrase1Part2": "los miembros del equipo recibirán una invitación",
  "SelectProjectFormPhrase2": "No tienes otro proyecto al que cambiarte.",
  "ok": "ok",

  "BackToGroup": "Volver a grupo",
  "BuilderSchedule": "Programa del Builder",
  "AddBuilders": "agregar builders",
  "UnsavedSheduleMessage": "Tienes un programa sin guardar. ¿Estás seguro de continuar?",
  "Cancel": "Cancelar",
  "Remove": "Retirar",
  "RemoveHubMemberText": "¿Estás seguro de que quieres eliminar este mimebro de tu Hub?",
  "RemoveHubGroupMemberText": "¿Estás seguro de que quieres eliminar este mimebro de tu grupo?",
  "Save": "Guardar",
  "inactive": "inactivo",
  "Projects": "Proyectos",
  "NoProjects": "¡Todavía no hay proyectos aquí!",
  "Members": "Miembros",
  "SearchMembers": "buscar miembros",
  "SeeMoreMembers": "ver más miembros",
  "Managers": "Propietarios",
  "AddedToGroupHeader": "Fuiste agregado al grupo:",
  "AddedToGroupMessage": "también se agregó automáticamente.",
  "AddedToGroupHint": "Sugerencia: puedes cambiar tu proyecto en cualquier momento en la página del grupo.",
  "Okay": "¡Okay!",
  "RemoveProject": "Quitar proyecto",
  "SwitchProject": "Cambiar proyecto",
  "GroupNameTakenError": "¡El nombre del grupo ya existe!",

  "NoResultsFound": "No se han encontrado resultados",
  "NoGroupsYet": "Aún no tienes grupos.",
  "HubGroupSubscriptionHeader": "Su plan de suscripción permite ",
  "HubGroupSubscriptionHeaderPart2": "grupos activos",
  "HubGroupSubscriptionMessage": "Actualiza para desbloquear grupos activos ilimitados",
  "HubGroupSubscriptionHint": "Sugerencia: puedes desactivar otro grupo para dejar espacio para este",
  "Upgrade": "Mejorar",

  "SelectImage": "Seleccionar imagen",
  "Image": "Imagen",
  "AddImage": "Añade una Imagen",
  "Preview": "Vista previa",
  "add": "Añadir",
  "AddVideoFromURL": "Agregar video desde URL",
  "ActivityMediaModal": "Medios de actividad Modal",
  "VideoURLPlaceholder": "Pega el enlace del video aquí",
  "VideoNotSupportedMessage": "Lo sentimos, tu navegador no admite videos incrustados.",
  "AnnouncementInputPlaceholder": "Hazlo saber a todos tus miembros (recibirán una notificación)",
  "sticky": "Fijar",
  "announce": "anunciar",
  "PostInputPlaceholder": "Comparte tus pensamientos",
  "post": "Post",
  "OfferInputPlaceholder": "¿Cómo puedes ayudar? No olvides agregar cómo las personas pueden comunicarse contigo / tu disponibilidad",
  "offer": "Oferta",
  "QuestionInputPlaceholder": "Agregar pregunta aquí",
  "QuestionInputOptionalPlaceholder": "Opcional: incluye detalles o enlace de referencia.",
  "ask": "pedir",
  "IdeaInputPlaceholder": "Agrega tu idea",
  "IdeaDetailInputPlaceholder": "Describe tu problema y solución con más detalle.",
  "CreatePost": "Crea una publicación",
  "MakeAnnouncement": "Hacer un anuncio",
  "MakeOffer": "Haz una oferta",
  "AddIdea": "Agrega una idea",
  "AskQuestion": "Hacer una pregunta",
  "question": "Pregunta",
  "idea": "Idea",
  "announcement": "Anuncio",
  "General": "General",
  "FormerRebel": "Antiguo Rebelde",
  "kudos": "kudos",
  "brainstorm": "lluvia de ideas",
  "brainstorms": "lluvia de ideas",
  "answer": "responder",
  "answers": "respuestas",
  "1reply": "Respuesta",
  "replies": "Respuestas",
  "reply": "respuesta....",
  "delete": "eliminar",
  "ReadMore": "leer más",
  "ShowLess": "muestra menos",
  "unstick": "Desfijar",
  "edit": "Editar",
  "Q+A": "P+R",
  "VotedBestAnswer": "Votada como mejor respuesta",
  "upvote": "voto a favor",
  "upvotes": "votos a favor",
  "IdeaSphere": "Ideas compartidas",
  "Offer": "Oferta",
  "Offers": "Ofertas",
  "ConfirmDeletion": "¿Estás seguro que quieres eliminar esto?",
  "Delete": "Eliminar",
  "NoGoBack": "No, vuelve",
  "YesDelete": "Si, borrar",
  "PostedByMe": "Publicado por mí",
  "FillAllFields": "Por favor llena todos los espacios.",
  "YouCanOnlySelectUpto5Images": "Solo puede seleccionar hasta 5 imágenes",

  "TypeHere": "¡escribe aquí!",
  "Brainstorm": "Lluvia de ideas",
  "Brainstorms": "Lluvia de ideas",
  "IdeaBrainstormsPhrase": "¿Es este el tipo de idea que te entusiasman? podrías llevar esta idea al siguiente nivel .",
  "AddToBrainstorm": "Agregar a la lluvia de ideas",
  "NothingHereYet": "todavía no hay nada aquí..",
  "Questions": "Preguntas",
  "IdeaQuestionsPhrase": "¿Alguna parte de esta idea te ha confundido? Haz preguntas relevantes, pide informaciones lógicos que faltan, exige pruebas y evidencias de apoyo .",
  "AddToQuestions": "Agregar a preguntas",
  "IdeaOffersPhrase": "¿Quieres ver este proyecto en toda su extensión? Contribuye con cualquier talento o recurso o referirlos a alguien que pueda ayudarlos .",
  "AddToOffers": "Agregar a ofertas",
  "backToActivities": "volver a actividades",
  "ConfirmIdeaDeletion": "¿Estás seguro de que deseas eliminar esta idea?",
  "support": "Apoyo",
  "AnswerDetailPlaceholder": "comparte tu conocimiento",
  "Question": "Pregunta",
  "Answer": "Responder",
  "Answers": "Respuestas",
  "OtherAnswers": "Otras respuestas",
  "NoAnswers": "Sin Respuestas",
  "NoOtherAnswers": "Sin Otras Respuestas.",
  "FirstToAnswer": "¡Se el primero en responder esta pregunta!",
  "ConfirmQuestionDeletion": "¿Estás seguro de que deseas eliminar esta pregunta?",

  "Pending": "Pendiente",
  "NoPendingInvitations": "No hay invitaciones pendientes",
  "SeeAll": "ver todo",
  "sent": "¡enviado",
  "SendNudge": "enviar recordatorio",
  "InviteMembers": "Invitar a los Miembros",
  "BrainTitle": "Bienvenido a Brain",
  "BrainPhrase1Part1": "Estar en el saber.",
  "BrainPhrase1Part2": "Esta es tu instantánea de lo que está sucediendo en tu hub",
  "hubGuide": "Guía del Hub",
  "rebelBaseHub101": "Iniciarse en los Hub de Rebelbase",
  "projectsBuilders": "Proyectos + Builders",
  "collaboration": "Colaboración",
  "inviteToYour": "Invita a tu Hub",
  "events": "Eventos",
  "onboardCohorts": "Incorpora grupos",
  "troubleshooting": "Resolución de Problemas",

  "SuccesfullySent": "Enviado con éxito",
  "invite": "invitación",
  "invites": "Invitaciones",
  "to": "a",
  "AlreadyMember": "Ya eres usuario",
  "already member": "Ya eres usuario",
  "AlreadyInvited": "Ya invitado",
  "already invited": "Ya invitado",
  "gel": "gel",
  "NudgeSent": "Nudge sent!",
  "ClickHere": "Haga clic aquí",
  "ClickHerePart2": "para enviarles un recordatorio.",
  "ErrorSending": "¡Opps! Error al enviar",
  "ThisEmail": "este correo electrónico",
  "TheseEmails": "estos correos electrónicos",
  "SelectRoles": "Seleccionar rol (s):",
  "Rebel": "Rebel",
  "WorkingOnInnovation": "Trabajando en la innovación",
  "Supporter": "Soporte",
  "LendingExpertise": "Prestando experiencia a los rebels",
  "NoRole": "Sin Rol",
  "InviteViaEmails": "Invitar por correo electrónico",
  "InviteViaEmailsPart2": "Usa una coma o un espacio para separar varias direcciones de correo electrónico",
  "PersonalizeInvitation": "Personaliza tu invitación con un mensaje",
  "AddYourMessage": "Agrega tu mensaje",
  "optional": "opcional",
  "SendInvite": "enviar invitación",
  "HubInviteTitle": "Invitar miembros a ",
  "Hub": "Hub",
  "InviteHubMembersModal": "Invitar a miembros del Hub Modal",

  "PendingInvites": "Invitaciones pendientes",
  "NoPendingInvitation": "No hay invitaciones pendientes.",
  "HubPendingInvitationsModal": "Invitaciones Pendientes Hub Modal",

  "LocationPlaceholder": "Busca tu ciudad aquí",
  "CreateYourHub": "Crea tu Hub",
  "Location": "Ubicación",
  "Type": "Tipo",
  "SelectType": "selecciona un tipo",
  "Website": "Sitio web",
  "Working": "Trabajando...",
  "Next": "Siguiente",

  "SkipForNow": "saltar por ahora",
  "Done": "Hecho",

  "SelectLogo": "seleccionar logo",
  "LogoHint": "JPG, PNG o GIF, hasta 5 MB.",
  "CreateHubStepTwoTitle": "Danos algunos detalles: haz que tu espacio destaque",
  "Logo": "Logo",
  "Description": "Descripción",
  "DescriptionPlaceholder": "Agregue una descripción de 1-3 oraciones sobre tu hub. (250 caracteres como máximo)",

  "EventsCase1": "Solo tu participaste",
  "EventsCase1Part2": "Solo tu estas participando",
  "You": "Tú",
  "Participated": "participaste",
  "Participants": "Participantes",
  "Participant": "participante",
  "Online": "Online",

  "Activity": "Actividad",
  "Event": "Evento",
  "NewEvent": "Nuevo Evento",
  "Public": "Público",
  "PastEvents": "Eventos Anteriores",
  "NoEventsYet": "Aún no hay eventos.",
  "CreateNewEvent": "crear un nuevo evento",

  "RoleAt": "Rol en",
  "AdminCardModal": "Tarjeta de administrador Modal",

  "SelectProjectsForHub": "Seleccionar Proyectos para Hub",
  "YouHaveNoProjects": "No tienes proyectos.",
  "ClickHereToCreateProject": "Haz clic aquí para crear un proyecto.",
  "RebelCardModal": "Tarjeta de rebel Modal",

  "WhatAreYourPowers": "Cuales son tus superpoderes? (máximo 10)",
  "PowerExamples": "es decir, finanzas, comunicación, branding ...",
  "PressEnterToAddTag": "presiona enter para agregar etiqueta",
  "BestWayToContactYou": "La mejor manera de ponerse en contacto contigo",
  "ContactPlaceholder": "es decir, cher@email.com, 652 200 3..., Cafetería a las 2pm los miércoles",
  "SupportCardModal": "Tarjeta de soporte Modal",

  "HubAdmin": "Administradores de Hub",
  "EditAdminRoleCard": "editar tarjeta de rol de administrador",
  "Project": "Proyecto",
  "noProjects": "sin proyectos",
  "EditRebelRoleCard": "editar tarjeta de rol rebelde",
  "Powers": "Superpoderes",
  "NoPowers": "Sin poderes",
  "HowToContact": "Como contactar",
  "NoContactInformation": "sin información de contacto",
  "EditSupportRoleCard": "editar tarjeta de rol de soporte",
  "admin": "administrador",
  "EditMembership": "Editar Membresía",
  "EditHubMembershipModal": "Editar modalidad de membresía de Hub",

  "HubJoinModal": "Unirse al Hub Modal",
  "HubJoinModalPhrase1": "Interactúa con una comunidad llena de brillantez, creatividad e innovación. El Hub es donde puedes ayudar a otros con sus proyectos, encontrar recursos que te ayuden con el tuyo y participar en eventos competitivos para ver cómo te desempeñas .",
  "HubJoinModalPhrase2": "Preséntate en el apartado de actividad.",
  "HubJoinModalPhrase3": "¡Anímate y empieza",
  "HubJoinModalPhraseCallToAction": "Complete tu información a continuación para que otros miembros te conozcan.",
  "ContinueToHub": "continuar en el hub",

  "HowToContactMe": "Como contactarme",
  "EmptyRebelCardPhrase1": "no has enviado ningún proyecto",
  "EmptyRebelCardPhrase2": "agrega proyectos al hub editando tu membresía del hub",
  "Partner": "Compañero",
  "Organization": "Organización",
  "PartnerCardPhrase1": "Asesor, Ted Talk",
  "PartnerCardPhrase2": "Envíe las solicitudes para ser parte de New School Ted X antes del 01 de septiembre.",
  "Judge": "Juez",
  "EventHistory": "Historial de eventos",
  "JudgeCardPhrase1": "14 de abril: Día de demostración de publicaciones",
  "Bio": "Bio",
  "JudgeCardPhrase2": "Trabajé aquí. Trabajé allí. Ya sabes a que me refiero.",
  "GoTo": "Ir a ",
  "your": "tu",
  "profile": "perfil",
  "MembershipModal": "Membresía Modal",
  "NoPowersYet": "sin superpoderes todavía",
  "NothingToSeeHere": "nada que ver aqui.",
  "SearchByName": "buscar por nombre",
  "SearchGroups": "buscar grupos",
  "*required": "*requerido",
  "filters": "filtros",
  "Admins": "Administradors",
  "NoMembersFound": "No se encontraron miembros.",
  "NoHubMembers": "No hay miembros del hub.",

  "ResendInvite": "reenviar invitación",

  "EditHubModal": "Editar modal de Hub",
  "ChangeHubDetails": "Cambiar los detalles del centro",
  "EditHubDescriptionPlaceholder": "Agregue una descripción de 1-3 oraciones sobre tu proyecto. 250 caracteres como máximo",
  "Saving": "Ahorro",

  "ChangeLogo": "cambiar logo",
  "member": "miembro",
  "EditMyRole": "Editar roles",
  "HideHeader": "ocultar encabezado",
  "ShowHeader": "mostrar encabezado",
  "Groups": "Grupos",

  "or": "o",
  "InactiveSubscription": "Esta suscripción de Hub está inactiva",
  "InactiveSubscriptionMessage": "Tu acceso al hub será limitado. Si cree que esto es un error, comuníquese con ellos para renovar.",
  "SubscriptionExpired": "¡Esta suscripción ha caducado!",
  "SubscriptionExpiredMessage": "Tu acceso al hub ahora es limitado. Por favor renueve poniéndose en contacto con nosotros.",
  "ContactUs": "Contacta con nosotros",

  "HubAdminSubscriptionExpireTitle": "Your Hub Subscription Expired",
  "HubAdminSubscriptionExpireMessage": "Your access to this hub is now limited. Please contact us to renew your subscription to regain full access to this hub",
  "HubMemberSubscriptionExpireTitle": "This Hub Subscription is Inactive",
  "HubMemberSubscriptionExpireMessage": "Your access to this hub is limited. If you feel this is a mistake, please contact the hub administrator",

  "PhotoLimit": "Gran foto pero superó el tamaño máximo: 3MB.",
  "SupportedFormats": "El formato de imagen no es compatible. Los formatos admitidos son jpg, jpeg, png, gif y jfif.",

  "MaxPhotoSize": "Gran foto, pero superó el tamaño máximo: 5 MB.",
  "YouAre": "Eres el",
  "an": "un",
  "a": "un",
  "YourEvents": "Tus Eventos",
  "editGroupName": "editar el nombre del grupo",
  "editMembers": "editar miembros",
  "editManagers": "editar gerentes",

  "InviteMembersTo": "Invitar miembros a",

  "MyEvents": "Mis eventos",
  "MaxLimitError": "El límite máximo de caracteres es 250.",

  "AddThoughts": "Comparte tus ideas",
  "GoBack": "Atrás",
  "ChoostPostType": "Elige el tipo de publicación",

  "postDesc": "¿En qué estás pensando?",
  "ideaDesc": "Escribe tus propias ideas para que otros colaboren",
  "questionDesc": "Pregunta para recibir respuestas",
  "offerDesc": "Habla sobre tus habilidades y experiencia con la comunidad",
  "announcementDesc": "Anúncialo y todos los miembros recibirán una notificación",

  "postCreatedSuccessfully": "Publicación subida correctamente",
  "createdSuccessfully": "publicada correctamente",

  "All": "Vista General",
  "Announcements": "Anuncios",
  "Posts": "Publicaciones",

  "Expand": "Expandir",

  "invitePeople": "Invitar a la gente",
  "inviteSentMsg": "Las invitaciones han sido enviadas",
  "InviteRemoveMsg": "Tus invitaciones han sido eliminadas",
  "errorSendingInviteMsg": "There were issues with some of the emails you provided, for more details",
  "errorMessage": "Error Message",
  "errorSendingInvites": "Error Sending Invites",
  "Last7days": "Últimos 7 días",
  "ShowAll": "Todos",
  "SortBy": "Organiza por:",
  "Last30Days": "Últimos 30 días",
  "Last90Days": "Últimos 90 días",
  "SearchByMail": "Buscar por email",
  "SearchInvitations": "Buscar invitaciones",
  "SelectAll": "Seleccionar todos",
  "DeselectAll": "Deseleccionar todos",
  "ResendAllInvites": "Reenviar todas las invitaciones",
  "ResendInvite ": "Reenviar invitación",
  "ResendSelectedInvites": "Reenviar las invitaciones seleccionadas",
  "DeleteSelectedInvites": "Eliminar invitaciones seleccionadas",
  "UserManagement": "Gestión de usuarios",
  "SearchHubMembers": "Buscar miembros en Hub",
  "SearchByNameOrEmail": "Buscar por nombre o email",
  "View": "Vista",
  "AllMembers": "Todos los miembros",
  "OwnerAdminsOnly": "Solo Administradores/Propietarios",
  "Owner": "Propietario",
  "Member": "Miembro",
  "Admin": "Administrador",
  "MembersOnly": "Solo miembros",
  "RecentlyJoined": "Recientemente Unidos",
  "AzLastName": "A-Z (Apellido)",
  "ZaLastName": "Z-A (Apellido)",
  "NoActiveInvitations": "No hay invitaciones activas",
  "NoActiveMembers": "No hay miembros activos",
  "AddByEmails": "Añadir por correo electrónico",

  "createGroup": "Crea un grupo",

  "searchByNameOrEmail": "Buscar por nombre o email",
  "searchGroupMembers": "Buscar miembros en Grupo",
  "hostsAndManagers": "Admin + Facilitadores",
  "members": "Miembros",
  "pendingMembers": "Miembros pendientes",
  "addPeopleToGroup": "Añadir gente a este grupo",
  "addMembersByEmail": "Añadir miembros al Hub por email",
  "addMembers": "Añadir miembros",
  "membersDirectory": "Directorio de miembros",
  "Host": "Admin",
  "Manager": "Manager",
  "NoBuildersAvailable": "No hay Builders que mostrar",
  "Add project to": "Add Project to",
  "shareAllYourWork": "Share all your hard work and get helpful feedback from your group facilitator and your peers by creating or adding an existing project to this group.",
  "createNewProjectFromScratch": "Create a new project from scratch",
  "createNewProject": "Create New Project",
  "chooseExistingProject": "Choose an existing project to add to your group",
  "addExistingProject": "Add Existing Project",
  "addAnExistingProject": "Add An Existing Project",
  "chooseAnExisitngProjectToAddTo": "Choose an existing project to add to",
  "addProject": "Add Project",
  "Search": "Buscar",
  "ManageMembers": "Administrar miembros",
  "SearchByNameAndPowers": "Búsqueda por Nombre o Poder",
  "HubMembers": "Miembros del centro",
  "Activities": "Actividades",
  "Events": "Eventos",
  "ReturnToMemberView": "Volver a la vista Rebel",
  "invalidEmail": "Por favor ingresa un correo electrónico válido",
  "errorUpdatingMemberRole": "Error al actualizar el rol del miembro",
  "memberRoleUpdatedSuccessfully": "Rol del miembro actualizado correctamente",
  "errorDeletingInvite": "Error al eliminar la invitación",
  "errorRemovingMember": "Error al eliminar al miembro",
  "successfullyDeletedInvite": "Invitación eliminada correctamente",
  "memberRemovedSuccessfully": "Miembro eliminado correctamente",
  "invitesResentSuccessfully": "Invitaciones reenviadas correctamente",
  "errorLoadingHubMembers": "Error al cargar los miembros del Hub"
}
